export const colorRanges = [
	{ min: 0, max: 24, color: '#EE2F4A', label: 'Below Average' },
	{ min: 25, max: 39, color: '#fda621', label: 'Fair' },
	{ min: 40, max: 59, color: '#000000', label: 'Average' },
	{ min: 60, max: 74, color: '#004168', label: 'Good' },
	{ min: 75, max: 89, color: '#5CCAEA', label: 'Strong' },
	{ min: 90, max: 100, color: '#128600', label: 'Elite' },
];

export const getColorRange = (score: number) => {
	return colorRanges.find((range) => score >= range.min && score <= range.max) || colorRanges[0];
};

export const getColor = (score: number) => {
	return getColorRange(score).color;
};
